import React from 'react';
import { connect } from 'react-redux';
import { ExpandingPanel } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import { getDeviceParameters } from "../../../../store/blocks/devices/parametersSelectors";
import { CompareDevices } from "./components/CompareDevices";
import { List } from "./components/List";
var _DeviceParameters = function _DeviceParameters(_ref) {
  var parameters = _ref.parameters;
  if (parameters.length > 1) {
    return /*#__PURE__*/React.createElement(CompareDevices, {
      data: parameters,
      "data-t-id": "components-DeviceParameters"
    });
  }
  return /*#__PURE__*/React.createElement("div", null, parameters[0].map(function (deviceParams) {
    return /*#__PURE__*/React.createElement(ExpandingPanel, {
      isOpen: true,
      key: deviceParams.title,
      size: "size4-m",
      title: deviceParams.title
    }, /*#__PURE__*/React.createElement(List, {
      data: deviceParams.items,
      "data-t-id": "components-DeviceParameters"
    }));
  }));
};
_DeviceParameters.propTypes = process.env.NODE_ENV !== "production" ? {
  parameters: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
    items: PropTypes.shape({
      comparedDeviceData: PropTypes.string,
      key: PropTypes.string,
      targetDeviceData: PropTypes.string
    }),
    title: PropTypes.string
  })))
} : {};
var mapStateToProps = function mapStateToProps(state) {
  return {
    parameters: getDeviceParameters(state)
  };
};
export var DeviceParameters = connect(mapStateToProps)(_DeviceParameters);